<form>
  <div class="form-sub-title">Titel</div>
  <mat-form-field appearance="outline">
    <mat-select
      [placeholder]="'Maak een keuze'"
      [(value)]="selectedTitle"
      (selectionChange)="titleChange($event.value)"
    >
      <mat-option
        *ngFor="let title of titleOptions; let i = index"
        [value]="title.label"
        >{{ title.label }}</mat-option
      >
    </mat-select>
  </mat-form-field>

  <mat-form-field
    class="left-space"
    appearance="outline"
    *ngIf="this.customTitle"
  >
    <input
      matInput
      placeholder="Titel"
      name="otherTitle"
      [(ngModel)]="this.inputProduct.title"
      [disabled]="disabled"
      (ngModelChange)="updateProduct.emit()"
    />
  </mat-form-field>

  <ng-container *ngIf="!client || inputProject.id != null">
    <div class="form-sub-title upper-space">
      Telefoonnummers
    </div>
    <div *ngFor="let projectContact of inputProject.projectContacts">
      <product-phone-number-selector
        *ngIf="inputProduct.id != null && projectContact.id != null"
        [inputProduct]="inputProduct"
        [inputProjectContact]="projectContact"
        (numberChanged)="updateProduct.emit()"
      ></product-phone-number-selector>
    </div>
  </ng-container>

  <ng-container *ngIf="client && inputProject.id == null">
    <div class="form-sub-title upper-space">
      Telefoonnummers
    </div>
    <client-product-phone-number-selector
      *ngIf="inputProject.projectContacts?.length > 0"
      [inputProduct]="inputProduct"
      [inputProjectContact]="inputProject.projectContacts[0]"
    ></client-product-phone-number-selector>
  </ng-container>

  <div class="form-sub-title upper-space">Tekst (gepersonaliseerde tekst)</div>
  <div class="d-flex">
    <mat-form-field class="wide" appearance="outline">
      <textarea
        matInput
        class="textarea"
        [ngClass]="client ? 'client-textarea' : ''"
        [(ngModel)]="inputProduct.text"
        [disabled]="disabled"
        (ngModelChange)="updateProduct.emit()"
        placeholder="Noteer hier uw tekst (vb: Commercieel handelspand met woonst)"
        name="text"
        cdkTextareaAutosize
      ></textarea>
    </mat-form-field>
  </div>
</form>
